import React from 'react';

const ReportFilterContext = React.createContext();
export default ReportFilterContext;
